import React, { ReactElement } from 'react';
import { View } from 'react-native';

import { openLink } from '../../utilities/links';
import GiveButton from './GiveButton';
import { PromptEvent } from './Types';

const GIVING_OPTIONS = [50, 100, 200]; // dollar amounts

export default ({
  givingUrl,
  showDefaultAmounts,
  sendPromptEvent,
}: {
  givingUrl: string;
  showDefaultAmounts: boolean;
  sendPromptEvent: (event: PromptEvent, options?: object) => void;
}): ReactElement | null => {
  return showDefaultAmounts ? (
    <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
      {GIVING_OPTIONS.map((give, i) => {
        return (
          <GiveButton
            key={i}
            text={`$${give}`}
            onPress={() => {
              sendPromptEvent(PromptEvent.promptClick, {
                defaultAmount: true,
                amount: give,
              });
              openLink(`${givingUrl}&amount=${give}`);
            }}
          />
        );
      })}
      <GiveButton
        onPress={() => {
          sendPromptEvent(PromptEvent.promptClick, {
            defaultAmount: true,
            amount: 'other',
          });
          openLink(givingUrl);
        }}
        text='Other'
      />
    </View>
  ) : null;
};
